import { gql } from '@apollo/client';
export const COUNTRIES = gql `
  query COUNTRIES($includeInactive: Boolean!) {
    countries(includeInactive: $includeInactive) {
      value
      label
      params
    }
  }
`;
